module.exports = __webpack_public_path__ + "img/Linkedin.c43a02a3.svg";